module.exports = __webpack_public_path__ + "media/images/background-service-premium_2-7d3d53b9.jpg";